import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Calendar = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C5.27614 0 5.5 0.223858 5.5 0.5V1H11.5V0.5C11.5 0.223858 11.7239 0 12 0C12.2761 0 12.5 0.223858 12.5 0.5V1H13.5C14.6046 1 15.5 1.89543 15.5 3V5.5V13C15.5 14.1046 14.6046 15 13.5 15H3.5C2.39543 15 1.5 14.1046 1.5 13V5.5V3C1.5 1.89543 2.39543 1 3.5 1H4.5V0.5C4.5 0.223858 4.72386 0 5 0ZM11.5 2V3C11.5 3.27614 11.7239 3.5 12 3.5C12.2761 3.5 12.5 3.27614 12.5 3V2H13.5C14.0523 2 14.5 2.44772 14.5 3V5L2.5 5V3C2.5 2.44772 2.94772 2 3.5 2H4.5V3C4.5 3.27614 4.72386 3.5 5 3.5C5.27614 3.5 5.5 3.27614 5.5 3V2H11.5ZM2.5 6L14.5 6V13C14.5 13.5523 14.0523 14 13.5 14H3.5C2.94772 14 2.5 13.5523 2.5 13V6ZM5.5 8V9H4.5V8H5.5ZM12.5 9V8H11.5V9H12.5ZM8 8H9V9H8V8ZM5.5 12V11H4.5V12H5.5ZM12.5 11V12H11.5V11H12.5ZM9 11H8V12H9V11Z"
        fill={color}
      />
      <path
        d="M14.5 2H2.5V5C2.5 5.55228 2.94772 6 3.5 6L13.5 6C14.0523 6 14.5 5.55228 14.5 5V2Z"
        fill="#2D425B"
        fillOpacity="0.1"
      />
      <path
        d="M15.5 6H1.5V13C1.5 13.5523 1.94772 14 2.5 14L14.5 14C15.0523 14 15.5 13.5523 15.5 13V6Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
    </svg>
  )
})

export default Calendar
